import styled from 'styled-components'

import { Typography } from '@corabank/arco'

export const DocsFormTitle = styled(Typography)`
  margin: 24px 0 8px;
`

export const DocsFormTexts = styled(Typography)`
  margin-bottom: 24px;

  a {
    color: ${({ theme }) => theme.colors.mainPrimary};
  }

  p {
    margin-bottom: 8px;
  }

  li {
    margin: 0 0 8px 24px;
  }
`

export const DocsFormFeedbackInfo = styled.span`
  display: flex;
  align-items: center;

  svg {
    margin-right: 16px;
  }
`
